import {KTSVG} from '../../../_metronic/helpers'
import {FC, useEffect, useState, forwardRef, useImperativeHandle} from 'react'


import {useAllpaymenttypes, useAllcustomers,useUpdatesalesinvoices} from '../../contextProviders/Atomqueryprovider'


import {Modal} from 'react-bootstrap'
import Select from 'react-select'
import { useSelectStyles } from '../../helpers/useSelectStyles'
type Props = {
  invoiceupdate: any
  invoiceData: any
  show: boolean
  handleClose: () => void

  ref: any

}


const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const API_URL = process.env.REACT_APP_API_URL
const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
export const Updateinvoice: FC<Props> = forwardRef((props, ref) => {
 

  const [updatesmade, setUpdatesmade] = useState(true)

  //customer id and payment type
  const [customer_id, setCustomer_id] = useState<any>(null)
  const [payment_type_id, setPayment_type_id] = useState<any>(null)
  const [splitpayment, setSplitpayment] = useState<any>([])
  const [jointmpesacashPayment, setJointmpesacashPayment] = useState(false)
  const [jointmpesatipPayment, setJointmpesatipPayment] = useState(false) // New state for MPESATIP
  const [paymentstatuschange, setPaymentstatuschange] = useState<any>(null)
  const [newSetpriceMpesa, setNewSetpriceMpesa] = useState<number>(0)
  const [newSetpriceCash, setNewSetpriceCash] = useState<number>(0)
  const [newSetpriceTip, setNewSetpriceTip] = useState<number>(0) // New state for TIP amount
  const [submitupdate, setSubmitupdate] = useState(false)


  const {
    isLoading:  allpaymenttypesloading,
    isSuccess:  allpaymenttypessuccess,
    data:  allpaymenttypesdata,
    status:allpaymenttypesstatus
  
  } = useAllpaymenttypes()


 const {
    isLoading: allcustomersloading,
    isSuccess: allcustomerssuccess,
    data: allcustomersdata,
   status: allcustomersstatus
   
  } = useAllcustomers()

  let customeroptions = allcustomerssuccess && allcustomersdata?.data.map((val: any, index: any) => {
    return {
      value: val.customer_id,
      label: val.customer_firstname + ' ' + val.customer_secondname,
    }
  })

  let paymentoptions = allpaymenttypessuccess && allpaymenttypesdata?.data.map((val: any, index: any) => {
    return {
      value: val.payment_type_id,
      label: val.payment_type_name,
    }
  })

  let paymentstatus = [
    {
      value: 'PAID',
      label: 'PAID',
    },
    {
      value: 'NOT PAID',
      label: 'NOT PAID',
    },
    {
      value: 'CREDIT',
      label: 'CREDIT',
    },
    {
      value: 'PARTIAL',
      label: 'PARTIAL',
    },
  ]
  
  const handlepaymentChange = (e: any) => {
    if (e != null) {
      setPayment_type_id(e.value)

      if(e.label === "MPESACASH")
      {
        setJointmpesacashPayment(true)
        setJointmpesatipPayment(false)
        setNewSetpriceMpesa(0)
        setNewSetpriceCash(0)
        setSplitpayment([])
      }
      else if(e.label === "MPESATIP") // New condition for MPESATIP
      {
        setJointmpesatipPayment(true)
        setJointmpesacashPayment(false)
        setNewSetpriceMpesa(Number(props.invoiceupdate.total_amount))
        setNewSetpriceTip(0)
        setSplitpayment([{total_amount: Number(props.invoiceupdate.total_amount), payment_type_name: "MPESA"},
          {total_amount: 0,  payment_type_name: "TIP"}
        ])
      }
      else{
        setJointmpesacashPayment(false)
        setJointmpesatipPayment(false)
        setSplitpayment([{total_amount: Number(props.invoiceupdate.total_amount), payment_type_name: e.label}
        ])
      }
    }
  }

  const handlepaidstatusChange = (e: any) => {
    if (e != null) {
      setPaymentstatuschange(e.value)
    }
  }

  const handlepricechangeMpesa = (e: any) => {
    setNewSetpriceMpesa(e.target.value)

    if(jointmpesacashPayment) {
      setSplitpayment([{total_amount: Number(e.target.value), payment_type_name: "MPESA"},
        {total_amount: Number(newSetpriceCash),  payment_type_name: "CASH"}
      ])
    } else if(jointmpesatipPayment) {
      setSplitpayment([{total_amount: Number(e.target.value), payment_type_name: "MPESA"},
        {total_amount: Number(newSetpriceTip),  payment_type_name: "TIP"}
      ])
    }
  }

  const handlepricechangeCash = (e: any) => {
    setNewSetpriceCash(e.target.value)
    setSplitpayment([{total_amount: Number(newSetpriceMpesa) , payment_type_name: "MPESA"},
      {total_amount: Number(e.target.value),  payment_type_name: "CASH"}
    ])
  }

  // New handler for TIP amount change
  const handlepricechangeTip = (e: any) => {
    setNewSetpriceTip(e.target.value)
    setSplitpayment([{total_amount: Number(newSetpriceMpesa) , payment_type_name: "MPESA"},
      {total_amount: Number(e.target.value),  payment_type_name: "TIP"}
    ])
  }

  const handlecustomerChange = (e: any) => {
    if (e != null) {
      setCustomer_id(e.value)
    }
  }
  useImperativeHandle(ref, () => ({
    Resetmodalupdatevalues() {
      setCustomer_id(null)
      setPayment_type_id(null)
      setPaymentstatuschange(null)
      setSubmitupdate(false)
      setUpdatesmade(true)
      setJointmpesacashPayment(false)
      setJointmpesatipPayment(false) // Reset MPESATIP state
      setSplitpayment([])
      setNewSetpriceCash(0)
      setNewSetpriceMpesa(0)
      setNewSetpriceTip(0) // Reset TIP amount
    },
  }))


  const itemstoupdate: any = [{
    customer_id: customer_id != null ? customer_id : props.invoiceupdate.customer_id,
    payment_type_id:  payment_type_id != null ? payment_type_id : props.invoiceupdate.payment_type_id,
    invoice_id:  props.invoiceupdate.invoice_id,
    status:  paymentstatuschange != null ? paymentstatuschange : props.invoiceupdate.status,
    split_payment: splitpayment
  }]

  
  
  const {mutateAsync: updateinvoicesalesmutateAsync} =  useUpdatesalesinvoices(itemstoupdate)



  const updatecurrentInvoice = async () => {
    setSubmitupdate(true)
    
    updateinvoicesalesmutateAsync(itemstoupdate, {
      onSuccess: () =>{
        setSubmitupdate(false)
        props.handleClose()

      },
      onError(error, variables, context) {
        console.log(error)
        setSubmitupdate(false)
        props.handleClose()
      },

    })
    
  }



  useEffect(() => {

   
   
    if(!jointmpesacashPayment && !jointmpesatipPayment && customer_id && paymentstatuschange && payment_type_id) 
    {
       if(customer_id !== props.invoiceupdate.customer_id ||
        paymentstatuschange !== props.invoiceupdate.status||
        payment_type_id !==  props.invoiceupdate.payment_type_id
           ){
      setUpdatesmade(false)
       }
       else{
        setUpdatesmade(true)
       }
    }

    // Updated condition for MPESACASH
    if(jointmpesacashPayment && customer_id && paymentstatuschange && payment_type_id && newSetpriceCash && newSetpriceMpesa) 
    {
       if(customer_id !== props.invoiceupdate.customer_id ||
        paymentstatuschange !== props.invoiceupdate.status||
        payment_type_id !==  props.invoiceupdate.payment_type_id ||
        newSetpriceMpesa !== Number(props.invoiceupdate.split_payment?.find((x:any) => x.payment_type_name === "MPESA")?.total_amount || 0) ||
        newSetpriceCash !== Number(props.invoiceupdate.split_payment?.find((x:any) => x.payment_type_name === "CASH")?.total_amount || 0)
           ){
            if(Number(props.invoiceupdate.total_amount) === (Number(newSetpriceCash) + Number(newSetpriceMpesa))){
              setUpdatesmade(false)
                }
                else{

                  setUpdatesmade(true)
                }
       } else {
        setUpdatesmade(true)
       }
    }

    // New condition for MPESATIP
    if(jointmpesatipPayment && customer_id && paymentstatuschange && payment_type_id && newSetpriceTip !== undefined && newSetpriceMpesa) 
    {
       if(customer_id !== props.invoiceupdate.customer_id ||
        paymentstatuschange !== props.invoiceupdate.status||
        payment_type_id !==  props.invoiceupdate.payment_type_id ||
        newSetpriceMpesa !== Number(props.invoiceupdate.split_payment?.find((x:any) => x.payment_type_name === "MPESA")?.total_amount || 0) ||
        newSetpriceTip !== Number(props.invoiceupdate.split_payment?.find((x:any) => x.payment_type_name === "TIP")?.total_amount || 0)
           ){
            if(newSetpriceTip > 0){
              setUpdatesmade(false)
                }
                else{

                  setUpdatesmade(true)
                }
       } else {
        setUpdatesmade(true)
       }
    }
  

  }, [customer_id, paymentstatuschange, payment_type_id, newSetpriceCash, newSetpriceMpesa, newSetpriceTip])


  useEffect(() => {

    setCustomer_id(props.invoiceupdate.customer_id)
    setPaymentstatuschange(props.invoiceupdate.status)
    setPayment_type_id(props.invoiceupdate.payment_type_id)

    if(props.invoiceupdate.payment_type_name === "MPESACASH"){
      setJointmpesacashPayment(true)
      setJointmpesatipPayment(false)

      setNewSetpriceMpesa(Number(props.invoiceupdate.split_payment?.find((x:any) => x.payment_type_name === "MPESA")?.total_amount || 0))
      setNewSetpriceCash(Number(props.invoiceupdate.split_payment?.find((x:any) => x.payment_type_name === "CASH")?.total_amount || 0))

      setSplitpayment([{total_amount: Number(props.invoiceupdate.split_payment?.find((x:any) => x.payment_type_name === "MPESA")?.total_amount || 0) , payment_type_name: "MPESA"},
        {total_amount: Number(props.invoiceupdate.split_payment?.find((x:any) => x.payment_type_name === "CASH")?.total_amount || 0),  payment_type_name: "CASH"}
      ])
    }
    else if(props.invoiceupdate.payment_type_name === "MPESATIP"){ // New condition for MPESATIP
      setJointmpesatipPayment(true)
      setJointmpesacashPayment(false)

      setNewSetpriceMpesa(Number(props.invoiceupdate.total_amount))
      setNewSetpriceTip(Number(props.invoiceupdate.split_payment?.find((x:any) => x.payment_type_name === "TIP")?.total_amount || 0))

      setSplitpayment([{total_amount: Number(props.invoiceupdate.total_amount) , payment_type_name: "MPESA"},
        {total_amount: Number(props.invoiceupdate.split_payment?.find((x:any) => x.payment_type_name === "TIP")?.total_amount || 0),  payment_type_name: "TIP"}
      ])
    }
    else{

      setJointmpesacashPayment(false)
      setJointmpesatipPayment(false)
      setSplitpayment([{total_amount: props.invoiceupdate.total_amount, payment_type_name:  props.invoiceupdate.payment_type_name}])
    }

  }, [props.show])

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>Update Invoice
          <span className='h-10px border-gray-200 border-start mx-2'></span>

           <span className='text-muted fw-bold fs-6'>{props.invoiceupdate.invoice_id}</span></h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form className='form' noValidate>
                {/* begin::Input group */}
                <div className='row'>
                <div className='col-lg-6 fv-row mb-7'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Total</label>
              {/* end::Label */}
              <div><span className='text-muted fw-bold fs-6'>{addCommas(Number(props.invoiceupdate.total_amount).toFixed(2))} {CURRENCY_APP} </span></div>
              </div>

              <div className='col-lg-6 fv-row mb-7'>
                
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2' style={{display: jointmpesacashPayment ? 'block' : 'none'}}>Split Amount</label>
              {/* end::Label */}
              <div style={{display: jointmpesacashPayment ? 'block' : 'none'}}>
                <span className='fw-bold fs-6 text-primary'>
                  {jointmpesacashPayment && addCommas(Number(Number(newSetpriceCash) + Number(newSetpriceMpesa)).toFixed(2))}
                  {' '}{CURRENCY_APP}
                </span>
              </div>
              </div>
            </div>
            {/* end::Input group */}
            {/* begin::Input group */}

            <div className='fv-row mb-7'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Customer</label>
              {/* end::Label */}

              <Select
                options={customeroptions}
                styles={useSelectStyles()}
                isDisabled={false}
                isLoading={allcustomersloading}
                defaultValue={allcustomerssuccess && customeroptions.filter(
                  (x: any) =>
                    x.value ==
                    props.invoiceupdate.customer_id
                )}
                placeholder={"Select customer ..."}
                isSearchable={true}
                onChange={(e: any) => handlecustomerChange(e)}
              />
            </div>
            {/* end::Input group */}


            {/* begin::Input group */}
            <div className='row'>
            <div className='col-lg-6 fv-row mb-7'>


                     {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Payment Status</label>
              {/* end::Label */}

              <Select
                options={paymentstatus}
                styles={useSelectStyles()}
                isDisabled={false}
                defaultValue={paymentstatus.filter(
                  (x: any) =>
                    x.value ==
                    props.invoiceupdate.status
                )}
                placeholder={"Select payment status ..."}
                isSearchable={true}
                onChange={(e: any) => handlepaidstatusChange(e)}
              />
            </div>


            <div className='col-lg-6 fv-row mb-7'>

                 {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Payment Mode</label>
              {/* end::Label */}
               <Select
                options={paymentoptions}
                styles={useSelectStyles()}
                isDisabled={false}
                isLoading={allpaymenttypesloading}
                defaultValue={allpaymenttypessuccess &&  paymentoptions.filter(
                  (x: any) =>
                    x.value ==
                  props.invoiceupdate.payment_type_id
                )}
                placeholder={"Select payment mode ..."}
                isSearchable={true}
                onChange={(e: any) => handlepaymentChange(e)}
              />
                </div>
                </div>

            {/* end::Input group */}

             {/* begin::Input group - MPESACASH */}

             <div className='row'>
            <div className='col-lg-6 fv-row mb-7' style={{display: jointmpesacashPayment ? 'block' : 'none'}}>
                    {/* begin::Label */}
             <label className='required fw-bold fs-6 mb-2'>MPESA</label>
             {/* end::Label */}

             <input
                      placeholder='0.00'
                      min='0'
                      step='.01'
                      className='form-control form-control-lg form-control-solid'
                      type='number'
                      autoComplete='off'
                      value={parseFloat(newSetpriceMpesa.toString()).toFixed(2)}
                      onChange={(e) => handlepricechangeMpesa(e)}
                    />
            </div>


            <div className='col-lg-6 fv-row mb-7' style={{display: jointmpesacashPayment ? 'block' : 'none'}}>
                {/* begin::Label */}
             <label className='required fw-bold fs-6 mb-2'>CASH</label>
             {/* end::Label */}
             <input
                  min='0'
                     step='.01'
                      placeholder='0.00'
                      className='form-control form-control-lg form-control-solid'
                      type='number'
                      autoComplete='off'
                      value={parseFloat(newSetpriceCash.toString()).toFixed(2)}
                      onChange={(e) => handlepricechangeCash(e)}
                    />


              </div>
           </div>
           {/* end::Input group - MPESACASH */}

           {/* begin::Input group - MPESATIP */}

           <div className='row'>
            <div className='col-lg-6 fv-row mb-7' style={{display: jointmpesatipPayment ? 'block' : 'none'}}>
                    {/* begin::Label */}
             <label className='required fw-bold fs-6 mb-2'>MPESA</label>
             {/* end::Label */}

             <input
                      placeholder='0.00'
                      min='0'
                      step='.01'
                      className='form-control form-control-lg form-control-solid'
                      type='number'
                      autoComplete='off'
                      value={parseFloat(newSetpriceMpesa.toString()).toFixed(2)}
                      onChange={(e) => handlepricechangeMpesa(e)}
                      disabled={true}
                    />
            </div>


            <div className='col-lg-6 fv-row mb-7' style={{display: jointmpesatipPayment ? 'block' : 'none'}}>
                {/* begin::Label */}
             <label className='required fw-bold fs-6 mb-2'>TIP AMOUNT</label>
             {/* end::Label */}
             <input
                  min='0'
                     step='.01'
                      placeholder='0.00'
                      className='form-control form-control-lg form-control-solid'
                      type='number'
                      autoComplete='off'
                      value={parseFloat(newSetpriceTip.toString()).toFixed(2)}
                      onChange={(e) => handlepricechangeTip(e)}
                    />


              </div>
           </div>
           {/* end::Input group - MPESATIP */}
          </form>
        </div>

        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-info'
            onClick={updatecurrentInvoice}
            disabled={updatesmade}
          >
            {!submitupdate && <span className='indicator-label'>Update Invoice</span>}
            {submitupdate && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
})